"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f118 = void 0;
exports.f118 = {
    "vaa": [
        "Taml"
    ],
    "vae": [
        "Latn"
    ],
    "vaf": [
        "Arab"
    ],
    "vag": [
        "Latn"
    ],
    "vah": [
        "Deva"
    ],
    "vai": [
        "Vaii",
        "Latn"
    ],
    "vaj": [
        "Latn"
    ],
    "val": [
        "Latn"
    ],
    "vam": [
        "Latn"
    ],
    "van": [
        "Latn"
    ],
    "vao": [
        "Latn"
    ],
    "vap": [
        "Latn"
    ],
    "var": [
        "Latn"
    ],
    "vas": [
        "Deva",
        "Gujr"
    ],
    "vau": [
        "Latn"
    ],
    "vav": [
        "Deva",
        "Gujr"
    ],
    "vay": [
        "Deva"
    ],
    "vbb": [
        "Latn"
    ],
    "vbk": [
        "Latn"
    ],
    "ve": [
        "Latn",
        "Brai"
    ],
    "vec": [
        "Latn"
    ],
    "ved": [
        "Zyyy"
    ],
    "vel": [
        "Zyyy"
    ],
    "vem": [
        "Latn"
    ],
    "veo": [
        "Latn"
    ],
    "vep": [
        "Latn"
    ],
    "ver": [
        "Latn"
    ],
    "vgr": [
        "Arab"
    ],
    "vgt": [
        "Zxxx"
    ],
    "vi": [
        "Latn",
        "Brai",
        "Hani"
    ],
    "vic": [
        "Latn"
    ],
    "vid": [
        "Latn"
    ],
    "vif": [
        "Latn"
    ],
    "vig": [
        "Latn"
    ],
    "vil": [
        "Latn"
    ],
    "vin": [
        "Latn"
    ],
    "vis": [
        "Zyyy"
    ],
    "vit": [
        "Latn"
    ],
    "viv": [
        "Latn"
    ],
    "vka": [
        "Latn"
    ],
    "vkj": [
        "Latn"
    ],
    "vkk": [
        "Latn"
    ],
    "vkl": [
        "Latn"
    ],
    "vkm": [
        "Latn"
    ],
    "vkn": [
        "Latn"
    ],
    "vko": [
        "Latn"
    ],
    "vkp": [
        "Deva",
        "Latn"
    ],
    "vkt": [
        "Latn"
    ],
    "vku": [
        "Latn"
    ],
    "vkz": [
        "Latn"
    ],
    "vlp": [
        "Latn"
    ],
    "vls": [
        "Latn"
    ],
    "vma": [
        "Latn"
    ],
    "vmb": [
        "Latn"
    ],
    "vmc": [
        "Latn"
    ],
    "vmd": [
        "Knda"
    ],
    "vme": [
        "Latn"
    ],
    "vmf": [
        "Latn"
    ],
    "vmg": [
        "Latn"
    ],
    "vmh": [
        "Zyyy"
    ],
    "vmi": [
        "Latn"
    ],
    "vmj": [
        "Latn"
    ],
    "vmk": [
        "Latn"
    ],
    "vml": [
        "Latn"
    ],
    "vmm": [
        "Latn"
    ],
    "vmp": [
        "Latn"
    ],
    "vmq": [
        "Latn"
    ],
    "vmr": [
        "Latn"
    ],
    "vms": [
        "Latn"
    ],
    "vmu": [
        "Latn"
    ],
    "vmv": [
        "Zyyy"
    ],
    "vmw": [
        "Latn",
        "Arab"
    ],
    "vmx": [
        "Latn"
    ],
    "vmy": [
        "Latn"
    ],
    "vmz": [
        "Latn"
    ],
    "vnk": [
        "Latn"
    ],
    "vnm": [
        "Latn"
    ],
    "vnp": [
        "Latn"
    ],
    "vo": [
        "Latn"
    ],
    "vor": [
        "Latn"
    ],
    "vot": [
        "Latn",
        "Cyrl"
    ],
    "vra": [
        "Latn"
    ],
    "vro": [
        "Latn"
    ],
    "vrs": [
        "Latn"
    ],
    "vrt": [
        "Latn"
    ],
    "vsi": [
        "Zxxx"
    ],
    "vsl": [
        "Zxxx"
    ],
    "vsv": [
        "Zxxx"
    ],
    "vto": [
        "Latn"
    ],
    "vum": [
        "Latn"
    ],
    "vun": [
        "Latn"
    ],
    "vut": [
        "Latn"
    ],
    "vwa": [
        "Zyyy"
    ]
};
